import { render, staticRenderFns } from "./SAvatar.vue?vue&type=template&id=0e557814&scoped=true&"
import script from "./SAvatar.vue?vue&type=script&lang=js&"
export * from "./SAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SAvatar.vue?vue&type=style&index=0&id=0e557814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e557814",
  null
  
)

export default component.exports